import { render } from "./ModuleNavBarCollapse.vue?vue&type=template&id=bb2ccc76"
import script from "./ModuleNavBarCollapse.vue?vue&type=script&lang=js"
export * from "./ModuleNavBarCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__